import { createBehavior } from '@area17/a17-behaviors';
const navigation = createBehavior('navigation',
    {

        toggleLogoVisibilityForAccessibility(toggled) {
            const lightMode = this.$node.classList.contains('light');
            const coBlue = '.navigation__co--blue';
            const coGold = '.navigation__co--gold';
            const usccBlue = '.navigation__chamber--blue';
            const usccWhite = '.navigation__chamber--white';
            if (!toggled && lightMode) {
                // CO Logo
                this.$node.querySelector(coGold)?.removeAttribute('aria-hidden');
                this.$node.querySelector(coGold)?.removeAttribute('tabindex');
                this.$node.querySelector(coBlue)?.setAttribute('aria-hidden', true);
                this.$node.querySelector(coBlue)?.setAttribute('tabindex', -1);
                // USCC Logo
                this.$node.querySelector(usccWhite)?.removeAttribute('aria-hidden');
                this.$node.querySelector(usccWhite)?.removeAttribute('tabindex');
                this.$node.querySelector(usccBlue)?.setAttribute('aria-hidden', true);
                this.$node.querySelector(usccBlue)?.setAttribute('tabindex', -1);
            } else if (lightMode) {
                // CO Logo
                this.$node.querySelector(coBlue)?.removeAttribute('aria-hidden');
                this.$node.querySelector(coBlue)?.removeAttribute('tabindex');
                this.$node.querySelector(coGold)?.setAttribute('aria-hidden', true);
                this.$node.querySelector(coGold)?.setAttribute('tabindex', -1);
                // USCC Logo
                this.$node.querySelector(usccBlue)?.removeAttribute('aria-hidden');
                this.$node.querySelector(usccBlue)?.removeAttribute('tabindex');
                this.$node.querySelector(usccWhite)?.setAttribute('aria-hidden', true);
                this.$node.querySelector(usccWhite)?.setAttribute('tabindex', -1);
            }
        },

        toggleExpandedMenuForAccessibility() {
            const isExpanded = this.$node.classList.contains('expanded');
            this.hamburger.setAttribute('aria-expanded', isExpanded);
            const expandedNavElements = this.$node.querySelectorAll('.navigation__footer, .navigation__sections-wrapper');
            for (let i = 0; i < expandedNavElements.length; i++) {
                expandedNavElements[i].setAttribute('aria-hidden', !isExpanded);
                if (isExpanded) {
                    expandedNavElements[i].removeAttribute('tabindex');
                } else {
                    expandedNavElements[i].setAttribute('tabindex', -1);
                }
                // recursively set aria-hidden on all children
                const children = expandedNavElements[i].querySelectorAll('button, a');
                for (let j = 0; j < children.length; j++) {
                    children[j].setAttribute('aria-hidden', !isExpanded);
                    if (isExpanded) {
                        children[j].removeAttribute('tabindex');
                    } else {
                        children[j].setAttribute('tabindex', -1);
                    }
                }
            }
        },

        navEvents () {

            this.hamburger.addEventListener('click', (e) => {
                this.$node.classList.toggle('expanded');
                this.toggleExpandedMenuForAccessibility();
            });
        },

        bodyLocked() {
            this.lockedBody = true;
        },
        bodyUnlocked() {
            this.lockedBody = false;
        },
        reset() {
            document.dispatchEvent(new CustomEvent('header:top'));
            this.scrollY = 0;
            this.scrollChangedAt = 0;
            this.scrollDirection = 'down';
            this.$node.style.top = '0';
            this.$node.classList.remove('s-fixed');
            this.state = 'top';
        },
        unfix() {
            document.dispatchEvent(new CustomEvent('header:absolute'));
            this.$node.classList.remove('s-fixed');
            this.$node.style.top = `${this.scrollChangedAt + this.h}px`;
            this.state = 'absolute';
        },
        fix() {
            document.dispatchEvent(new CustomEvent('header:fixed'));
            this.$node.classList.add('s-fixed');
            this.state = 'fixed';
        },
        scrollWatcher() {
            const scrollY = window.pageYOffset;

            // if scroll position is the same, do nothing
            if (scrollY !== this.scrollY && !this.lockedBody) {
                if (scrollY < 1) {
                    // reset at the top
                    this.reset();
                } else {

                    const scrollDirection = (scrollY > this.scrollY) ? 'down' : 'up';

                    // looks like scroll position changed
                    if (this.scrollDirection !== scrollDirection) {
                        this.scrollChangedAt = scrollY;
                        this.scrollDirection = scrollDirection;

                        // if we're going up, set lock top value
                        // header is still position absolute
                        // so will end up scrolling back into view
                        if (scrollDirection === 'up') {
                            const lockTop = this.scrollChangedAt - this.h;
                            this.$node.style.top = `${lockTop > 0 ? lockTop : 0}px`;
                        }
                    }

                    // if we're going up and the header is fully in view
                    // fix its position so it doesn't keep sticking to the page scroll
                    if (this.state !== 'fixed' && scrollDirection === 'up' && this.scrollChangedAt - scrollY > this.h) {
                        this.fix();
                    }

                    // if we're going down and we've scrolled further than height of
                    // the header, unstick it
                    // using the header height to stop the hide/show feeling nervous
                    if (this.state !== 'absolute' && scrollDirection === 'down' && this.scrollChangedAt > 0 && scrollY - this.scrollChangedAt > this.h) {
                        this.unfix();
                    }

                    this.scrollY = scrollY;
                }
            }

            this.loop = window.requestAnimationFrame(this.scrollWatcher);
        },
    },
    {
        init() {
            this.hamburger = this.$node.querySelector('.navigation__hamburger');

            this.navEvents();
            this.toggleLogoVisibilityForAccessibility();
            this.toggleExpandedMenuForAccessibility();

            if (this.$node.dataset.allowLock === '1') {
                // handle navigation show/hide on scroll
                this.scrollY = -1;
                this.h = this.$node.offsetHeight;
                this.scrollChangedAt = 0;
                this.scrollDirection = '';
                this.state = 'top';
                this.lockedBody = false;

                document.addEventListener('body:lock', this.bodyLocked, false);
                document.addEventListener('body:unlock', this.bodyUnlocked, false);
                document.addEventListener('stickyNav:fix', this.fix, false);
                document.addEventListener('stickyNav:reset', this.reset, false);
                this.loop = window.requestAnimationFrame(this.scrollWatcher);
            }

        },
        resized() {
            this.h = this.$node.offsetHeight;
        },
        destroy() {
            document.removeEventListener('body:lock', this.bodyLocked);
            document.removeEventListener('body:unlock', this.bodyUnlocked);
            document.removeEventListener('stickyNav:fix', this.fix);
            document.removeEventListener('stickyNav:reset', this.reset);
            try {
                window.cancelAnimationFrame(this.loop);
            } catch (err) {
            }
        },
    }
);

export default navigation;